import React, { useEffect, useState } from "react";
import { Button, Modal, ModalDialog, Option, Radio, RadioGroup, Select } from "@mui/joy";
import totalLocationData from "../../../../../../data/locationdata";
import { koreanLocationToEnglish } from "../../../../../../data/locationFuntion";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";

const AddDefaultWorkSettingModal: React.FC<any> = (props) => {

    const [location, setLocation] = useState<string | undefined>(undefined);
    const [jobType, setJobType] = useState<string | undefined>(undefined);
    const [selectedJob, setSelectedJob] = useState<string | undefined>(undefined);

    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {

        if(props.user && props.open){

            const location = koreanLocationToEnglish(props.user.location);

            console.log(props.user.location);
            setLocation(location);
        }

    }, [props.user, props.open]);

    const submit = async () => {

        try{

            if(!location || !selectedJob || !props.data){
                return;
            }

            setSubmitLoading(true);

            const result : any = await postFetch("/dashboard/salary/adddefaultworksetting", {
                userId : props.user.id,
                location : location,
                english : selectedJob
            });

            if(result.message === "success"){
                props.setUpdate(Math.random());
                props.setUpdate2(Math.random());
                props.notify("success", "업무가 성공적으로 추가되었습니다.");
                props.onClose();
            }

            if(result.message === "DUPLICATE"){
                props.notify("error", "이미 등록된 기본 근무 설정입니다.");
                props.onClose();
            }

            setSubmitLoading(false);

        }catch(e){
            console.log(e);
        }

    }


    return (
        <Modal
            open={props.open}
            onClose={() => { props.onClose() }}
        >
            <ModalDialog>
                <div style={{
                    width: "300px"
                }}>
                    {
                        (props.data)
                        &&
                        <div>
                            <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "15px" }}>
                                기본 근무 추가
                            </div>

                            <div>
                                <div style={{
                                    fontWeight : 600
                                }}>
                                    근무 지점 선택
                                </div>
                                <div>
                                    <Select placeholder="지점을 선택해주세요"
                                        value={location}
                                        onChange={(e: any, newValue: any) => {

                                            setLocation(newValue)
                                        }}
                                        style={{ width: "300px", marginTop: "6px" }}
                                    >
                                        {
                                            totalLocationData.map((data, index: number) => {

                                                if (!data.academy.includes("sunbae") && !data.academy.includes("bundangsunbae")) {
                                                    return;
                                                }

                                                if (data.english === "total") {
                                                    return;
                                                }

                                                return (
                                                    <Option key={index} value={data.english}>
                                                        {data.korean}
                                                    </Option>
                                                )

                                            })
                                        }
                                    </Select>
                                </div>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                                <div style={{
                                    fontWeight : 600
                                }}>
                                    근무 위치 선택
                                </div>
                                <div style={{
                                    marginTop : "16px"
                                }}>
                                    <RadioGroup
                                    orientation="horizontal"
                                    value={jobType}
                                    onChange={(e: any) => {
                                        setJobType(e.target.value);
                                    }}
                                    >
                                        <Radio
                                        value="desk"
                                        label={<span>데스크</span>}
                                        />
                                        <Radio
                                        value="manager"
                                        label={<span>사감</span>}
                                        />
                                        <Radio
                                        value="duty"
                                        label={<span>당직</span>}
                                        />
                                    </RadioGroup>
                                </div>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                                <div style={{
                                    fontWeight : 600
                                }}>
                                    근무 종류 선택
                                </div>
                                <div style={{
                                    marginTop : "8px",
                                    display : "flex",
                                    alignItems : "center",
                                }}>
                                    <RadioGroup
                                    value={selectedJob}
                                    onChange={(e: any) => {
                                        setSelectedJob(e.target.value);
                                    }}
                                    >
                                        {
                                            (location && props.data[location])
                                            ?
                                            props.data[location].jobs.map((job: any, index: number) => {

                                                var isAvailable = true;

                                                if(job.isAvailable === false){
                                                    isAvailable = false;
                                                }

                                                if(!isAvailable){
                                                    return;
                                                }


                                                const type = job.type;

                                                if(!type){
                                                    return;
                                                }

                                                if(!type.includes(jobType)){
                                                    return;
                                                }

                                                return (
                                                    <Radio
                                                    key={index}
                                                    value={job.english}
                                                    label={<span>{job.korean}</span>}
                                                    />
                                                )


                                            })
                                            :
                                            ""
                                        }
                                    </RadioGroup>
                                </div>
                            </div>

                            <div style={{ marginTop: "30px" }}>
                                <Button
                                fullWidth
                                loading={submitLoading}
                                onClick={submit}
                                >
                                    추가하기
                                </Button>
                            </div>
                            
                        </div>
                    }
                </div>
            </ModalDialog>
        </Modal>
    )

}

export default AddDefaultWorkSettingModal;